import { defineSlotRecipe } from '@chakra-ui/react'

export const assiduousDialogRecipe = defineSlotRecipe({
  className: 'assiduous-dialog',
  slots: [
    'backdrop',
    'positioner',
    'content',
    'header',
    'body',
    'footer',
    'title',
    'description',
  ],
  base: {
    backdrop: {
      bg: 'dialog.backdrop',
    },
    positioner: {
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      p: 0,
    },
    content: {
      bg: 'surface.panel',
      borderRadius: '8px',
      boxShadow: '2xl',
      color: 'text.primary',
      display: 'flex',
      flexDirection: 'column',
      h: 'calc(100dvh - 32px)',
      maxH: 'calc(100dvh - 32px)',
      maxW: 'calc(100% - 32px)',
      overflow: 'hidden',
      position: 'relative',
      w: 'calc(100% - 32px)',
      '@media (min-width: 768px)': {
        h: 'calc(100dvh - 48px)',
        maxH: 'calc(100dvh - 48px)',
        maxW: 'calc(100% - 48px)',
        w: 'calc(100% - 48px)',
      },
    },
    header: {
      alignItems: 'flex-start',
      bg: 'surface.panel',
      borderBottomWidth: '1px',
      borderColor: 'border.default',
      display: 'flex',
      flexDirection: 'column',
      flex: '0 0 auto',
      flexShrink: 0,
      gap: 1,
      h: 'auto',
      minH: '64px',
      position: 'sticky',
      px: { base: 4, md: 6 },
      py: { base: 4, md: 5 },
      pe: { base: 14, md: 16 },
      top: 0,
      zIndex: 1,
    },
    body: {
      flex: 1,
      minH: 0,
      overflowX: 'hidden',
      overflowY: 'auto',
      px: { base: 4, md: 6 },
      py: { base: 5, md: 6 },
    },
    footer: {
      alignItems: 'center',
      bg: 'surface.panel',
      borderColor: 'border.default',
      borderTopWidth: '1px',
      display: 'flex',
      flexShrink: 0,
      flexWrap: 'wrap',
      gap: 2,
      justifyContent: 'flex-end',
      position: 'sticky',
      px: { base: 4, md: 6 },
      py: { base: 3, md: 4 },
      bottom: 0,
      zIndex: 1,
    },
    title: {
      color: 'text.primary',
      fontSize: 'md',
      fontWeight: 'semibold',
      lineHeight: 'short',
    },
    description: {
      color: 'text.secondary',
      fontSize: 'sm',
      lineHeight: 'base',
      w: '100%',
    },
  },
  variants: {
    layout: {
      small: {
        content: {
          h: 'auto',
          maxH: 'calc(100dvh - 32px)',
          maxW: '560px',
          w: 'calc(100% - 32px)',
          '@media (min-width: 768px)': {
            h: 'auto',
            maxH: 'calc(100dvh - 48px)',
            w: '560px',
          },
          '& [data-part="header"]': {
            borderBottomWidth: '0',
          },
          '& [data-part="footer"]': {
            borderTopWidth: '0',
          },
        },
        header: {
          borderBottomWidth: '0',
        },
        footer: {
          borderTopWidth: '0',
        },
      },
      medium: {
        content: {
          h: 'auto',
          maxH: 'calc(100dvh - 48px)',
          maxW: 'calc(100% - 32px)',
          w: 'calc(100% - 32px)',
          '@media (min-width: 768px)': {
            maxH: 'calc(100dvh - 96px)',
            maxW: '680px',
            w: '680px',
          },
        },
        body: {
          overflowX: 'hidden',
          overflowY: 'auto',
        },
      },
      large: {
        content: {
          h: 'auto',
          maxH: 'calc(100dvh - 48px)',
          maxW: 'calc(100% - 32px)',
          overflow: 'hidden',
          w: 'calc(100% - 32px)',
          '@media (min-width: 768px)': {
            maxH: 'calc(100dvh - 96px)',
            maxW: '600px',
            w: '90vw',
          },
          '@media (min-width: 1024px)': {
            maxH: 'calc(100dvh - 120px)',
            maxW: '640px',
            w: '640px',
          },
          '@media (min-width: 1280px)': {
            maxH: 'calc(100dvh - clamp(144px, 11.11vw, 160px))',
            maxW: '960px',
            w: 'clamp(720px, 55.56vw, 960px)',
          },
        },
        body: {
          overflowX: 'hidden',
          overflowY: 'auto',
        },
      },
      fullscreen: {
        content: {
          h: '90dvh',
          maxH: '90dvh',
          maxW: '90dvw',
          w: '90dvw',
        },
      },
    },
  },
  defaultVariants: {
    layout: 'large',
  },
})
